// External packages
import { z } from 'zod';

// Components
import { Button } from 'components/Button';
import { FileInputField } from 'components/FileInput';
import { Form } from 'components/Form';
import * as Modal from 'components/Modal';

const placeMapFormSchema = z.object({
  placeMap: z.instanceof(File).refine((file) => file instanceof File, {
    message: 'Unesite mapu',
  }),
});

type AddPlaceMapModalProps = {
  onSubmit: (data: z.infer<typeof placeMapFormSchema>) => Promise<void> | void;
  modalTrigger?: React.ReactNode;
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  isPending?: boolean;
};

export const AddPlaceMapModal: React.FC<AddPlaceMapModalProps> = ({
  onSubmit,
  modalTrigger,
  isOpen,
  onOpenChange,
  isPending = false,
}) => {
  return (
    <Modal.TriggerRoot isOpen={isOpen} onOpenChange={onOpenChange}>
      {modalTrigger}
      <Modal.Overlay isDismissable>
        <Modal.Root>
          <Modal.Dialog>
            <Modal.Close />
            <h3 className="mb-8 text-2xl text-gray-600">Dodaj mapu</h3>
            <Form schema={placeMapFormSchema} onSubmit={onSubmit}>
              <FileInputField
                fileTriggerProps={{
                  acceptedFileTypes: [
                    'image/jpeg',
                    'image/png',
                    'image/gif',
                    'image/webp',
                    'image/svg+xml',
                  ],
                }}
                label="Mapa"
                name="placeMap"
              />
              <Button
                type="submit"
                className="w-full mt-12"
                size="lg"
                isPending={isPending}
              >
                Dodaj mapu
              </Button>
            </Form>
          </Modal.Dialog>
        </Modal.Root>
      </Modal.Overlay>
    </Modal.TriggerRoot>
  );
};
